import { render, staticRenderFns } from "./VasTransactions.vue?vue&type=template&id=fc041118&scoped=true"
import script from "./VasTransactions.vue?vue&type=script&lang=js"
export * from "./VasTransactions.vue?vue&type=script&lang=js"
import style0 from "./VasTransactions.vue?vue&type=style&index=0&id=fc041118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc041118",
  null
  
)

export default component.exports